function init() {

    // First check if a categories block exists
    const categoriesBlock = document.querySelector('.wp-block-categories-list');
    
    // Only proceed if we found a categories block
    if (categoriesBlock) {
        // Get the category parameter from URL and remove trailing slash if it exists
        const urlParams = new URLSearchParams(window.location.search);
        const activeCategory = urlParams.get('category_filter')?.replace(/\/$/, '');
        
        // Create "All" list item
        const allItem = document.createElement('li');
        const allLink = document.createElement('a');
        
        // Get current URL without parameters
        const baseUrl = window.location.href.split('?')[0];
        
        allLink.href = baseUrl;
        allLink.textContent = 'All';
        allLink.classList.add('wp-block-categories-list__link');
        
        // Add active class if no category filter is active
        if (!activeCategory) {
            allLink.classList.add('active-category');
        }
        
        allItem.appendChild(allLink);
        categoriesBlock.insertBefore(allItem, categoriesBlock.firstChild);

        // If there's an active category, find and mark the matching link
        if (activeCategory) {
            const categoryLinks = categoriesBlock.querySelectorAll('a');
            
            categoryLinks.forEach(link => {
                const href = new URL(link.href);
                const linkCategory = href.searchParams.get('category_filter')?.replace(/\/$/, '');
                
                if (linkCategory === activeCategory) {
                    link.classList.add('active-category');
                }
            });
        }
    }
}

export {init as default}